import { PublicKey } from '@solana/web3.js';


// QuickNode RPC Endpoint
export const SOLANA_RPC_ENDPOINT = 'https://burned-purple-daylight.solana-mainnet.quiknode.pro/85875ec414ca8dba3a5ab0f36a3f4b3e23368211';

export const OHIO_TOKEN_MINT_ADDRESS = '8VRfgKJY5CnfgGkstisB3QgLPWM6xYBK4esrfN5Hpump';
export const OHIO_TOKEN_MINT = new PublicKey(OHIO_TOKEN_MINT_ADDRESS);